module.exports = __webpack_public_path__ + "img/zs20.ba3d431d.jpg";